import { FC } from 'react'
import { Box } from '@mui/material'
import { Skeleton } from '../../../../components/Skeleton/Skeleton'
import { SidePanel } from './SidePanel'

// Loading placeholder for the engagement side panel, shared across every ERT mode while data loads.
export const SidePanelSkeleton: FC = () => (
  <Skeleton isLoading={true} variant="rectangular" width="29.5rem" height="100%" sx={{ transform: 'none' }} />
)

// Fallback shown once loading finishes but there's no engagement/activity data to display.
export const NoEngagementDataSidePanel: FC = () => (
  <SidePanel>
    <Box
      sx={{ padding: 'var(--spacing-m)', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
      data-testid="side-panel-no-data"
    >
      No engagement or activities data available
    </Box>
  </SidePanel>
)
